import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.config.productionTip = false
Vue.use(Vant)
import { setUserInfo, getUserInfo, removeUserInfo } from '@/utils/storage'

// 挂到原型
Vue.prototype.$setUserInfo = setUserInfo
Vue.prototype.$getUserInfo = getUserInfo
Vue.prototype.$removeUserInfo = removeUserInfo

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')


